import moment from 'moment-timezone';
import { useState } from 'react';

export function cronTime() {
  const nextCron = moment.tz('America/Los_Angeles').hour(38).minute(0).second(0);
  const diff = nextCron.diff(moment().tz('America/Los_Angeles'));

  const duration = moment.duration(diff);
  const hours = duration.hours().toString().padStart(2, '0');
  const minutes = duration.minutes().toString().padStart(2, '0');
  const seconds = duration.seconds().toString().padStart(2, '0');
  const timeToNextCron = `${hours}:${minutes}:${seconds}`;
  return {
    timeToNextCron,
  };
}
